/*
 * BioIndex
 * Copyright (c) 2026 BioIndex™. All rights reserved.
 * Unauthorized copying, scraping, redistribution, or commercial reuse is prohibited.
 */

export const FORUM_CATEGORIES = [
  "General Discussion",
  "Species Identification",
  "BioIndex Taxonomy",
  "Photography Tips",
  "BioIndex Feature Requests",
  "BioIndex Bug Report",
];

export const DEFAULT_FORUM_CATEGORY = FORUM_CATEGORIES[0];

export function isValidForumCategory(category) {
  return FORUM_CATEGORIES.includes(String(category || "").trim());
}
